import 'slick-carousel'

// Ensure slick library has been included
if ( typeof $.fn.slick == 'function' ) {

    const $js_slider = $( '.js-slider' );

    var slickSettings = {
        lazyLoad: 'ondemand',
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fal fa-chevron-left fa-2x color-gray" aria-hidden="true"></i></button></i>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fal fa-chevron-right fa-2x color-gray" aria-hidden="true"></i></button>'
    };

    if ( 
        $js_slider.hasClass( 'slider-component__content-services' ) 
        || $js_slider.hasClass( 'slider-component__content-images' ) 
    ) {
        slickSettings.responsive = [
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true
                }
            }
        ];
    }
    
    $js_slider.slick(slickSettings);
}
